import { ReactNode } from 'react';
import { Menu } from 'lucide-react';
import { Separator } from '@/components/ui/separator.js';
import { Button } from '@/components/ui/button.js';
import { UserMenu } from '@/components/auth/UserMenu.js';

interface PageHeaderProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  onOpenDrawer?: () => void;
  isMobile?: boolean;
}

export function PageHeader({ icon, title, subtitle, actions, onOpenDrawer, isMobile }: PageHeaderProps) {
  return (
    <>
      <header className="flex items-center justify-between px-3 md:px-6 py-3 md:py-4 border-b border-border/50">
        <div className="flex items-center gap-2 md:gap-3 min-w-0 flex-1">
          {/* Mobile: Hamburger menu button */}
          {isMobile && onOpenDrawer && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onOpenDrawer}
              className="h-9 w-9 flex-shrink-0 -ml-1"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}

          {icon && <div className="flex-shrink-0">{icon}</div>}
          <div className="min-w-0 flex-1">
            <h1 className="text-base md:text-lg font-semibold text-foreground truncate">{title}</h1>
            {subtitle && <p className="text-xs text-muted-foreground truncate hidden md:block">{subtitle}</p>}
          </div>
        </div>

        <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
          {actions}
          <UserMenu />
        </div>
      </header>
      <Separator className="border-border/50" />
    </>
  );
}
